import React, { useEffect } from "react"
import ClassCard from "components/card/class"

import {
  CategoryModalContainer,
  CategoryModalContent,
  CategoryModalFooter,
  CategoryModalHeader,
  CategoryModalTitle,
  CategoryModalTitleContainer,
  CustomizedModal,
  FeaturedCardsGrid,
  FooterClosePopUp,
  RemoveIcon,
} from "./styles"
import ClassesCategoryTable from "../table"

const CategoryModal = ({ isOpen, featured, classes, setIsOpen, title }) => {
  const [featuredClasses, setFeaturedClasses] = React.useState([])
  useEffect(() => {
    const filteredElements =
      classes && classes.filter((element) => featured.includes(element.classId))
    setFeaturedClasses(filteredElements)
  }, [classes, featured])

  if (!isOpen) {
    return null
  }

  return (
    isOpen && (
      <CustomizedModal
        onClose={() => {
          setIsOpen(false)
          setFeaturedClasses([])
        }}
      >
        <CategoryModalContainer>
          <CategoryModalHeader>
            <RemoveIcon onClick={() => setIsOpen(false)} />
          </CategoryModalHeader>
          <CategoryModalContent>
            <CategoryModalTitleContainer>
              <CategoryModalTitle> {`${classes?.length} ${title} Classes`}</CategoryModalTitle>
            </CategoryModalTitleContainer>
            {featuredClasses?.length > 0 && (
              <FeaturedCardsGrid
                numColumns={{ default: 3, desktopL: 3, desktop: 2, tablet: 2, mobile: 1 }}
                rowMargin="2.8rem"
                colMargin="2.8rem"
              >
                {featuredClasses.map((cls) => (
                  <ClassCard
                    aria-label={cls.title}
                    inline
                    key={cls.id}
                    headline={cls.title}
                    imageUrl={`//res.mindbodygreen.com/${cls.image.path}`}
                    author={cls.instructors.length ? `${cls?.instructors[0]?.name}` : null}
                    urlKey={cls.urlKey}
                    lazyLoadImage
                    isGrid
                  />
                ))}
              </FeaturedCardsGrid>
            )}
            <ClassesCategoryTable classes={classes} />
          </CategoryModalContent>
          <CategoryModalFooter>
            <FooterClosePopUp
              onClick={() => {
                setIsOpen(false)
                setFeaturedClasses([])
              }}
            >
              Close popup
            </FooterClosePopUp>
          </CategoryModalFooter>
        </CategoryModalContainer>
      </CustomizedModal>
    )
  )
}

export default CategoryModal
